import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../button';

class LoginButton extends Component {
   constructor(props) {
      super(props);
      this.state = {};
   }

   render() {
      let text = 'Iniciar sesión';
      if (this.props.loading) {
         text = (
            <div>
               <span className="fas fa-spinner fa-spin"></span>
            </div>
         );
      }
      return (
         <Button id="btn-login" type="submit">
            {text}
         </Button>
      );
   }
}

function mapStateToProps(state) {
   return {
      loading: state.login_loading,
   };
}

export default connect(mapStateToProps)(LoginButton);



// WEBPACK FOOTER //
// ./src/components/Login/loginButton.js